import React, { createContext } from 'react'

import { AnimatedList } from '@pb/components'
import { Controller } from 'react-hook-form'

import ErrorMessage from './ErrorMessage'

// @ts-expect-error ts-migrate(2554) FIXME: Expected 1 arguments, but got 0.
export const RadioButtonListContext = createContext()

const RadioButtonContextProvider: React.FC<any> = ({ children, ...controllerProps }) => {
  return (
    <RadioButtonListContext.Provider value={controllerProps}>
      {children}
    </RadioButtonListContext.Provider>
  )
}

export const RadioButtonAnimatedList: React.FC<any> = ({
  showMoreButton,
  displayShowMoreButton,
  animationControl,
  children,
  name,
  ...props
}) => {
  return (
    <>
      <AnimatedList
        displayShowMoreButton={displayShowMoreButton}
        showMoreButton={showMoreButton}
        initial="hidden"
        animate={animationControl}
        {...props}
      >
        {children}
      </AnimatedList>

      <ErrorMessage name={name} />
    </>
  )
}

export const RadioButtonList: React.FC<any> = ({
  Wrapper = RadioButtonAnimatedList,
  children,
  name,
  rules,
  ...props
}) => {
  return (
    <Controller
      name={name}
      rules={rules}
      defaultValue={null}
      render={({ ref, ...fieldProps }) => (
        <RadioButtonContextProvider {...fieldProps}>
          <Wrapper {...props} {...ref}>
            {children}
          </Wrapper>
        </RadioButtonContextProvider>
      )}
    />
  )
}

export default RadioButtonList
